import { array, boolean, object, string } from 'yup'
import { PlanSettingsFormValues } from './utils'

const planOutputSchema = object({
  showGeometry: boolean().required(),
  showLabel: boolean().required(),
  showDetail: boolean().required(),
}).default(undefined)

export const planSettingsSchema = object({
  planStoreyPolicy: string().oneOf(['ElementStorey', 'UserDefined']).required(),
  storeysForPlans: array().of(string().required()).required(),
  use_global_live_loads: boolean(),
  pdf: planOutputSchema,
  dxf: planOutputSchema,
})

export type PlanSettingsSchema = PlanSettingsFormValues
